import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
// ---- image imports ----
import img01 from "../../images/team/1.png";
import img02 from "../../images/team/2.png";
import img03 from "../../images/team/3.png";
import img04 from "../../images/team/4.png";
import img05 from "../../images/team/5.png";
import img06 from "../../images/team/6.png";
import img07 from "../../images/team/7.png";
import img08 from "../../images/team/8.png";
import img09 from "../../images/team/9.png";
import img10 from "../../images/team/10.png";
import img11 from "../../images/team/11.png";
import img12 from "../../images/team/12.png";
import img13 from "../../images/team/13.png";
import img14 from "../../images/team/14.png";
import img15 from "../../images/team/15.png";
import img16 from "../../images/team/16.png";
import img17 from "../../images/team/17.png";
import img18 from "../../images/team/18.png";
import img19 from "../../images/team/19.png";
import img20 from "../../images/team/20.png";
import img21 from "../../images/team/21.png";
import img22 from "../../images/team/22.png";
import img23 from "../../images/team/23.png";
import img24 from "../../images/team/24.png";
import img25 from "../../images/team/25.png";
import img26 from "../../images/team/26.png";
import img27 from "../../images/team/27.png";
import img28 from "../../images/team/28.png";
import img29 from "../../images/team/29.png";
import img30 from "../../images/team/30.png";
import img31 from "../../images/team/31.png";
import img32 from "../../images/team/32.png";
import img33 from "../../images/team/33.png";
import img34 from "../../images/team/34.png";
import img35 from "../../images/team/35.png";
import img36 from "../../images/team/36.png";
import img37 from "../../images/team/37.png";
import img38 from "../../images/team/38.png";
import img39 from "../../images/team/39.png";
import img40 from "../../images/team/40.png";
import img41 from "../../images/team/41.png";
import img42 from "../../images/team/42.png";
import img43 from "../../images/team/43.png";
import img44 from "../../images/team/44.png";
import img45 from "../../images/team/45.png";
import img46 from "../../images/team/46.png";
import img47 from "../../images/team/47.png";
import img48 from "../../images/team/48.png";
import img49 from "../../images/team/49.png";
import img50 from "../../images/team/50.png";
import img51 from "../../images/team/51.png";
import img52 from "../../images/team/52.png";
import img53 from "../../images/team/53.png";
import img54 from "../../images/team/54.png";
import img55 from "../../images/team/55.png";
import img56 from "../../images/team/56.png";
import img57 from "../../images/team/57.png";
import img58 from "../../images/team/58.png";
import img59 from "../../images/team/59.png";
import img60 from "../../images/team/60.png";

import bgLarge from "../../images/team/noice-bg02.png";
import bgSmall from "../../images/team/noice-bg.png";


// ---- team data ----
const teamMembers = [
  {
    name: "Meheer Ali Khan",
    role: "Data Analyst",
    img: img01,
    big: false,
  },
  {
    name: "Ahmad Abdullah ",
    role: "Data Analyst",
    img: img02,
    big: false,
  },
  {
    name: "Adison Chakma",
    role: "Data Analyst",
    img: img03,
    big: false,
  },
  {
    name: "Taslima Akter",
    role: "Research Analyst",
    img: img04,
    big: false,
  },
  {
    name: "Sajib Hossain",
    role: "Political Analyst",
    img: img05,
    big: false,
  },
  {
    name: "Lob Chondro Paul",
    role: "Psychological Analyst",
    img: img06,
    big: false,
  },
  {
    name: "Sharif Hossain",
    role: "Educational Analyst",
    img: img07,
    big: false,
  },
  {
    name: "Sumon Chowdhury",
    role: "Educational Analyst",
    img: img08,
    big: false,
  },
  {
    name: "Pappu Dey",
    role: "Educational Analyst",
    img: img09,
    big: false,
  },
  {
    name: "Shirajul Islam",
    role: "Educational Analyst",
    img: img10,
    big: false,
  },
  {
    name: "Raju Hossen",
    role: "Research Analyst",
    img: img11,
    big: false,
  },
  {
    name: "Samiul",
    role: "Research Analyst",
    img: img12,
    big: false,
  },
  {
    name: "Md. Tarikul Islam",
    role: "Research Analyst",
    img: img13,
    big: false,
  },
  {
    name: "Niyaz Hossain Durjoy",
    role: "Behaviour Analyst",
    img: img14,
    big: false,
  },
  {
    name: "Arju Akter",
    role: "Research Analyst",
    img: img15,
    big: false,
  },
  {
    name: "Raihan Hossain",
    role: "Research Analyst",
    img: img16,
    big: false,
  },
  {
    name: "Nipun Chandra Roy",
    role: "Research Analyst",
    img: img17,
    big: false,
  },
  {
    name: "Tashrif Ahmed",
    role: "Research Analyst",
    img: img18,
    big: false,
  },
  {
    name: "Abu Sayeed",
    role: "Research Analyst",
    img: img19,
    big: false,
  },
  {
    name: "Mukta Das",
    role: "Research Analyst",
    img: img20,
    big: false,
  },
  {
    name: "S M Shamiul Hossain",
    role: "Political Analyst",
    img: img21,
    big: false,
  },
  {
    name: "Mehedi Hasan Sabbir",
    role: "Social Research Analyst",
    img: img22,
    big: false,
  },
  {
    name: "Tasrip Ahmed",
    role: "Research Analyst",
    img: img23,
    big: false,
  },
  {
    name: "Sima Rani Shil",
    role: "Research Analyst",
    img: img24,
    big: false,
  },
  {
    name: "Manik chandro shill",
    role: "Research Analyst",
    img: img25,
    big: false,
  },
  {
    name: "Tasnim Chowdhury",
    role: "Research Analyst",
    img: img26,
    big: false,
  },
  {
    name: "Abu Rayhan",
    role: "Data Analyst",
    img: img27,
    big: false,
  },
  {
    name: "Shahab Uddin",
    role: "Political Analyst",
    img: img28,
    big: false,
  },
  {
    name: "Abu Syeed Akanda",
    role: "Research Analyst",
    img: img29,
    big: false,
  },
  {
    name: "Farhatun Safia Etu",
    role: "Social Research Analyst",
    img: img30,
    big: false,
  },
  {
    name: "Mahedi Hasan",
    role: "Political Analyst",
    img: img31,
    big: false,
  },
  {
    name: "MD.Almas",
    role: "Research Analyst",
    img: img32,
    big: false,
  },
  {
    name: "Anik Nath",
    role: "Research Analyst",
    img: img33,
    big: false,
  },
  {
    name: "Ria Khanom Ami",
    role: "Research Analyst",
    img: img34,
    big: false,
  },
  {
    name: "S. M. Abdullah",
    role: "Research Analyst",
    img: img35,
    big: false,
  },
  {
    name: "Shaharia Ahmmed",
    role: "Research Analyst",
    img: img36,
    big: false,
  },
  {
    name: "Ovijit Roy Apon",
    role: "Research Analyst",
    img: img37,
    big: false,
  },
  {
    name: "S M Ashif Rayhan",
    role: "Research Analyst",
    img: img38,
    big: false,
  },
  {
    name: "Md Takveer Ahmed",
    role: "Political Analyst",
    img: img39,
    big: false,
  },
  {
    name: "MD. Sabuj Bhuiyan",
    role: "Political Analyst",
    img: img40,
    big: false,
  },
  {
    name: "Mahbuba Parvin Ritu",
    role: "Social Research Analyst",
    img: img41,
    big: false,
  },
  {
    name: "Shreya Das Monisha",
    role: "Research Analyst",
    img: img42,
    big: false,
  },
  {
    name: "Tanjila Akhter",
    role: "Research Analyst",
    img: img43,
    big: false,
  },
  {
    name: "Trima Ghosh",
    role: "Social Research Analyst",
    img: img44,
    big: false,
  },
  {
    name: "Badhan Chandra Sarker",
    role: "Research Analyst",
    img: img45,
    big: false,
  },
  {
    name: "Md:Belal Hossain",
    role: "Research Analyst",
    img: img46,
    big: false,
  },
  {
    name: "Md. Shamiur Rahman",
    role: "Research Analyst",
    img: img47,
    big: false,
  },
  {
    name: "Humaira Tasnim",
    role: "Data Analyst",
    img: img48,
    big: false,
  },
  {
    name: "Nur Alom",
    role: "Research Analyst",
    img: img49,
    big: false,
  },
  {
    name: "Md. Morshedul Islam",
    role: "Research Analyst",
    img: img50,
    big: false,
  },
  {
    name: "Shamiul Islam",
    role: "Research Analyst",
    img: img51,
    big: false,
  },
  {
    name: "Md. Abdul Malek",
    role: "Research Analyst",
    img: img52,
    big: false,
  },
  {
    name: "Priyanti Saha Archi",
    role: "Research Analyst",
    img: img53,
    big: false,
  },
  {
    name: "Md. Mahmudul Hasan",
    role: "Research Analyst",
    img: img54,
    big: false,
  },
  {
    name: "Sunjeda Afross",
    role: "Research Analyst",
    img: img55,
    big: false,
  },
  {
    name: "Syed MD Nazmus Sakib",
    role: "Educational Analyst",
    img: img56,
    big: false,
  },
  {
    name: "Shaimun Haque",
    role: "Research Analyst",
    img: img57,
    big: false,
  },
  {
    name: "Md. Monir Hossain",
    role: "Research Analyst",
    img: img58,
    big: false,
  },
  {
    name: "Farjana Farha",
    role: "Research Analyst",
    img: img59,
    big: false,
  },
  {
    name: "Prottoy Das",
    role: "Data Analyst",
    img: img60,
    big: false,
  },

 
];

const Interns: React.FC = () => {
  useEffect(() => {
                              document.title = "Interns | Brain Machine AI";
                            }, []);
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Our Interns" pagesub="Our Intern" />
            <section className="team">
              <div className="container">
                <div className="row mt-none-55">
                  {teamMembers.map((item, idx) => (
                    <div
                      key={idx}
                      className={
                        item.big
                          ? "col-xl-6 col-lg-6 col-md-8 mt-55"
                          : "col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-55"
                      }
                    >
                      <div
                        className={
                          item.big
                            ? "xb-team-item xb-team-item-big xb-border"
                            : "xb-team-item xb-border"
                        }
                      >
                        <div className="xb-item--img">
                          <img src={item.img} alt={item.name} />
                        </div>

                        <div className="xb-item--holder ul_li_between">
                          <div className="xb-item--author">
                            <h2 className="xb-item--name ">{item.name}</h2>
                            <span className="xb-item--desig">{item.role}</span>
                          </div>

                          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="xb-item--social xb-border">
                            <i className="fa-brands fa-linkedin-in"></i>
                          </a>
                        </div>

                        <div className="xb-bg">
                          <img src={item.big ? bgLarge : bgSmall} alt="background" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Interns;
